import script from "./SplitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitButton.vue?vue&type=script&setup=true&lang=ts"

import "./SplitButton.vue?vue&type=style&index=0&id=19cfd165&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19cfd165"]])

export default __exports__